import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../../../../lib/hooks/use-translate'
import { CurrencyEnum } from '../../../../../../lib/types/enums/common/currency.enum'
import CenterActivityTable from '../../../../ol-common/ol-center-program/center-activity-table'
import CenterAdminAndGrandExpenses from '../../../../ol-common/ol-center-program/center-admin-and-grand-expenses'
import CenterLocalTransportPricingTable from '../../../../ol-common/ol-center-program/center-local-transport-pricing-table'
import CenterLocalPricingEditableTable from '../../../../ol-personal-space/ol-personal-space-center-program/center-local-pricing-editable-table'

type Props = {
  centerId: number
  currency?: CurrencyEnum
  mode: 'open' | 'validate' | 'view' | 'staff-view'
}

const OlCenterProgramDetails = ({ centerId, currency, mode }: Props) => {
  const { t } = useTranslate()
  return (
    <div>
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        {t('ol.center.program.activities.table.title')}
      </Typography>
      <div className="h-3" />
      <CenterActivityTable centerId={centerId} currency={currency} mode={mode} />
      <div className="my-5 border-t border-dashed border-grey-stroke w-full" />
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        {t('ol.center.local.transport.table.title')}
      </Typography>
      <div className="h-2" />
      <Badge variant="primary" text={'Bus pass price for the stay per student'} />
      <div className="h-2" />
      {mode === 'open' ? (
        <CenterLocalPricingEditableTable centerId={centerId} currency={currency} />
      ) : (
        <CenterLocalTransportPricingTable centerId={centerId} currency={currency} mode={mode} />
      )}
      <div className="my-5 border-t border-dashed border-grey-stroke w-full" />
      <CenterAdminAndGrandExpenses currency={currency} centerId={centerId} mode="staff-view" />
    </div>
  )
}

export default OlCenterProgramDetails
